import { createSlice } from '@reduxjs/toolkit';

const singleClickSlice = createSlice({
  name: "singleClick",
  initialState: { singleClick:false },
  reducers: {

    toggleSingleClick(state,action) {
        state.singleClick = action.payload;  // Toggles the singleClick state
      },
  },
});

export const { toggleSingleClick } =
singleClickSlice.actions;
export default singleClickSlice.reducer;